import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSelectAll$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSelectAll extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '483cb680b1eef4d8e4fb4eb4065a21b5fe756fab', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '57c608337c01f345ba465af89be6e5c664061445', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '10c7767fdb8380aa8275006dc15a7f037d3f55a9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7 5.5v-2a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5h1v-9h-9v1A.5.5 0 0 1 8 6h-.5a.5.5 0 0 1-.5-.5m-4 13v-10a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5m1.631-4.348 2.638 2.306a.6.6 0 0 0 .846-.058l4.275-4.87a.5.5 0 0 0-.046-.705l-.376-.329a.5.5 0 0 0-.705.046l-3.684 4.2-1.961-1.714a.5.5 0 0 0-.706.048l-.328.376a.5.5 0 0 0 .047.7", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-select-all", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-select-all"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-select-all":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSelectAll$1);
            }
            break;
    } });
}

const CosmosIconSelectAll = CosmosIconSelectAll$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSelectAll, defineCustomElement };
